<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营管理</el-breadcrumb-item>
      <el-breadcrumb-item>充值设置</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-tabs v-model="activeType" @tab-click="getList">
        <el-tab-pane label="积分充值档位" name="1"></el-tab-pane>
        <el-tab-pane label="会员档位" name="2"></el-tab-pane>
      </el-tabs>

      <el-row style="margin: 6px 0 16px">
        <el-button type="primary" icon="el-icon-plus" @click="openAdd">新增档位</el-button>
        <span class="page-tip">
          此处维护的是前端「我的资产 → 充值 / 开通会员」页面展示的档位：金额、赠送积分、会员类型与时长。
        </span>
      </el-row>

      <el-table :data="list" border stripe v-loading="loading" empty-text="暂无档位">
        <el-table-column prop="sort_no" label="排序" width="70" align="center" />
        <el-table-column prop="config_key" label="标识" width="110" align="center" />
        <el-table-column prop="config_title" :label="activeType === '2' ? '会员类型' : '档位名称'" min-width="140" />
        <el-table-column label="金额（元）" width="120" align="center">
          <template v-slot="scope">
            <span class="money">¥{{ toFixed2(scope.row.config_money) }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="activeType === '1'" label="赠送积分" width="110" align="center">
          <template v-slot="scope">{{ scope.row.config_point }}</template>
        </el-table-column>
        <el-table-column v-else label="会员时长" width="110" align="center">
          <template v-slot="scope">{{ scope.row.config_month }} 个月</template>
        </el-table-column>
        <el-table-column prop="config_desc" label="说明" min-width="150" show-overflow-tooltip />
        <el-table-column label="启用" width="80" align="center">
          <template v-slot="scope">
            <el-switch
              v-model="scope.row.yong_flag"
              :active-value="1"
              :inactive-value="0"
              @change="toggleYong(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="170" align="center">
          <template v-slot="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="doDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增 / 编辑弹窗 -->
    <el-dialog
      :title="form.uid ? '编辑档位' : '新增档位'"
      :visible.sync="dialogVisible"
      width="540px"
      @close="resetForm"
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="档位名称" prop="config_title">
          <el-input v-model="form.config_title" :placeholder="form.config_type === 2 ? '如：月会员 / 季会员 / 年会员' : '如：68元充值'" />
        </el-form-item>
        <el-form-item label="金额（元）" prop="config_money">
          <el-input-number v-model="form.config_money" :min="0.01" :precision="2" :step="10" />
        </el-form-item>
        <el-form-item v-if="form.config_type === 1" label="赠送积分" prop="config_point">
          <el-input-number v-model="form.config_point" :min="1" :step="100" />
        </el-form-item>
        <el-form-item v-else label="会员时长(月)" prop="config_month">
          <el-input-number v-model="form.config_month" :min="1" :step="1" />
        </el-form-item>
        <el-form-item label="档位标识" prop="config_key">
          <el-input v-model="form.config_key" placeholder="留空自动生成，如 p1 / v1（同一类型下不可重复）" />
        </el-form-item>
        <el-form-item label="说明">
          <el-input v-model="form.config_desc" placeholder="可留空，例如：赠送680积分" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort_no" :min="0" :step="1" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.yong_flag" :active-value="1" :inactive-value="0" />
          <span class="form-tip">停用后前端不再展示该档位</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeType: '1', // 1 积分充值  2 开通会员
      list: [],
      loading: false,
      saving: false,
      dialogVisible: false,
      form: this.emptyForm(1),
      rules: {
        config_title: [{ required: true, message: '请输入档位名称', trigger: 'blur' }],
        config_money: [{ required: true, message: '请输入金额', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    emptyForm(type) {
      return {
        uid: 0,
        config_type: Number(type),
        config_key: '',
        config_title: '',
        config_money: undefined,
        config_point: undefined,
        config_month: undefined,
        config_desc: '',
        sort_no: 0,
        yong_flag: 1
      }
    },
    toFixed2(v) {
      return Number(v || 0).toFixed(2)
    },

    async getList() {
      this.loading = true
      try {
        const { data: res } = await this.$http.get('get_api', {
          params: { C_type: 'chongzhi_config_list', config_type: Number(this.activeType) }
        })
        const resData = JSON.parse(res.data)
        if (!resData || resData.length === 0) {
          this.list = []
          return
        }
        if (resData[0].status !== 200) {
          this.list = []
          this.$message.error(resData[0].msg || '档位加载失败')
          return
        }
        this.list = resData[0].dataList || []
      } catch (e) {
        console.error('充值档位加载失败', e)
        this.list = []
        this.$message.error('档位加载失败')
      } finally {
        this.loading = false
      }
    },

    openAdd() {
      this.form = this.emptyForm(this.activeType)
      // 默认排序放在最后
      this.form.sort_no = this.list.length + 1
      this.dialogVisible = true
    },
    openEdit(row) {
      this.form = {
        uid: row.uid,
        config_type: Number(row.config_type),
        config_key: row.config_key,
        config_title: row.config_title,
        config_money: Number(row.config_money),
        config_point: row.config_point === null || row.config_point === undefined ? undefined : Number(row.config_point),
        config_month: row.config_month === null || row.config_month === undefined ? undefined : Number(row.config_month),
        config_desc: row.config_desc || '',
        sort_no: row.sort_no || 0,
        yong_flag: Number(row.yong_flag)
      }
      this.dialogVisible = true
    },
    resetForm() {
      this.form = this.emptyForm(this.activeType)
      if (this.$refs.formRef) this.$refs.formRef.clearValidate()
    },

    async save() {
      if (this.form.config_type === 1 && !this.form.config_point) {
        return this.$message.warning('请填写赠送积分')
      }
      if (this.form.config_type === 2 && !this.form.config_month) {
        return this.$message.warning('请填写会员时长(月)')
      }
      this.saving = true
      try {
        const { data: res } = await this.$http.post('api', {
          C_type: 'chongzhi_config_save',
          uid: this.form.uid || 0,
          config_type: this.form.config_type,
          config_key: this.form.config_key,
          config_title: this.form.config_title,
          config_money: this.form.config_money,
          config_point: this.form.config_point,
          config_month: this.form.config_month,
          config_desc: this.form.config_desc,
          sort_no: this.form.sort_no,
          yong_flag: this.form.yong_flag
        })
        const r = JSON.parse(res.data)[0]
        if (r.status !== 200) {
          this.$message.error(r.msg || '保存失败')
          return
        }
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.getList()
      } catch (e) {
        console.error('保存档位失败', e)
        this.$message.error('保存失败')
      } finally {
        this.saving = false
      }
    },

    // 启用 / 停用：直接按整行数据保存
    async toggleYong(row) {
      try {
        const { data: res } = await this.$http.post('api', {
          C_type: 'chongzhi_config_save',
          uid: row.uid,
          config_type: row.config_type,
          config_key: row.config_key,
          config_title: row.config_title,
          config_money: row.config_money,
          config_point: row.config_point,
          config_month: row.config_month,
          config_desc: row.config_desc,
          sort_no: row.sort_no,
          yong_flag: row.yong_flag
        })
        const r = JSON.parse(res.data)[0]
        if (r.status !== 200) {
          this.$message.error(r.msg || '操作失败')
        } else {
          this.$message.success(row.yong_flag === 1 ? '已启用' : '已停用')
        }
        this.getList()
      } catch (e) {
        console.error('切换档位状态失败', e)
        this.$message.error('操作失败')
        this.getList()
      }
    },

    async doDelete(row) {
      try {
        await this.$confirm(`确定删除档位「${row.config_title || row.config_key}」吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return // 取消
      }
      try {
        const { data: res } = await this.$http.post('api', {
          C_type: 'chongzhi_config_del',
          uid: row.uid
        })
        const r = JSON.parse(res.data)[0]
        if (r.status !== 200) {
          this.$message.error(r.msg || '删除失败')
          return
        }
        this.$message.success('删除成功')
        this.getList()
      } catch (e) {
        console.error('删除档位失败', e)
        this.$message.error('删除失败')
      }
    }
  }
}
</script>

<style scoped>
.page-tip {
  margin-left: 12px;
  font-size: 13px;
  color: #909399;
}
.money {
  color: #f53f3f;
  font-weight: bold;
}
.form-tip {
  margin-left: 10px;
  font-size: 12px;
  color: #909399;
}
</style>
